import { TextField } from '@mui/material';
import parsePhoneNumberFromString from 'libphonenumber-js';
import { useState } from 'react';
import { useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const PhoneField = ({ name }) => {
  const { t } = useTranslation();
  const {
    field: { ref, onChange, ...fieldRest },
    fieldState: { error },
  } = useController({ name, defaultValue: '' });

  const [phoneNumber, setPhoneNumber] = useState(fieldRest.value);

  return (
    <TextField
      id={name}
      label={t('forgotPassword.phone.label')}
      placeholder={`${t('forgotPassword.phone.label')}...`}
      size="small"
      error={!!error}
      helperText={error?.message}
      slotProps={{
        inputLabel: {
          shrink: true,
          style: { fontSize: `calc(0.875rem * 4/3)` },
        },
        htmlInput: {
          onChange: event => {
            const newPhoneNumber = parsePhoneNumberFromString(
              event.target.value,
              'US',
            );
            if (newPhoneNumber) {
              if (newPhoneNumber.nationalNumber.length > 10) return;
              if (newPhoneNumber.nationalNumber.length === 10) {
                setPhoneNumber(newPhoneNumber.formatNational());
                onChange(newPhoneNumber.nationalNumber);
                return;
              }
            }
            onChange(event.target.value);
            setPhoneNumber(event.target.value);
          },
          value: phoneNumber,
          autoComplete: 'tel-national',
        },
      }}
      inputRef={ref}
      {...fieldRest}
    />
  );
};
export default PhoneField;
